import "./common.css";
import "./Header.css";

import { useContext, useEffect, useState, useRef } from "react";

import { HeaderContext } from "../../utils/HeaderContext";
import { SVTUserContext } from "../../utils/SVTUserContext";
import hitachiLogo from "../../assets/hitachi-logo.png";
import logoutIcon from "../../assets/logoutIcon.svg";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { useTranslation } from "react-i18next";
import { useMsal } from "@azure/msal-react";
import worldIcon from "../../assets/world.png";
import { Tooltip } from "react-tooltip";
import { useLocation } from "react-router-dom";
import { OktaAuth } from "@okta/okta-auth-js";
import { getOktaConfig } from "../../oktaConfig";

const Header = ({ headerName, isLandingPage }) => {
  const { i18n, t } = useTranslation();
  const { headerState } = useContext(HeaderContext);
  const [isLangPopupOpen, setIsLangPopupOpen] = useState(false);
  // const [selectedLanguage, setSelectedLanguage] = useState("en");
  const selectedLanguage = sessionStorage.getItem("selectedLanguage") || "en";
  const { instance } = useMsal();
  const popupRef = useRef(null);
  const userIconRef = useRef(null);
  const langPopupRef = useRef(null);
  const langIconRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { setActiveTab } = useContext(SVTUserContext);
  const navigate = useNavigate();
  // const { oktaAuth } = useOktaAuth();
  const oktaConfigType = sessionStorage.getItem("oktaConfigType");
  const oktaAuth = new OktaAuth(getOktaConfig(oktaConfigType));
  const [userName, setUserName] = useState("");
  const userNameObj = JSON.parse(
    sessionStorage.getItem("okta-token-storage") || "{}"
  );
  const isExternalUserSurvey = sessionStorage.getItem("isExternalUserSurvey");
  const location = useLocation();
  const [isAssessmentPresent, setIsAssessmentPresent] = useState(false);
  const [isExternalUserQuePage, setIsExternalUserQuePage] = useState(() => {
    return JSON.parse(sessionStorage.getItem("isExternalUserQuestionsPageOpen")) || false;
  });
  const [isUserSurveyQuePage, setIsUserSurveyQuePage] = useState();


  const languageMap = {
    en: { id: 1, name: "en" },
    ch: { id: 19, name: "ch" },
    jp: { id: 2, name: "jp" }
  };

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
    isAdminScreen();
    setIsSidebarOpen(headerState);
  }, [headerName, headerState]);

  useEffect(() => {
    const msalAccount = instance.getAllAccounts(); // Get the active MSAL account
    const name = userNameObj?.idToken?.claims?.name || msalAccount[0]?.name;
    const cleanName = name?.replace(/,/g, "");
    setUserName(cleanName);
    // Set selected language
    const currentLang = sessionStorage.getItem("selectedLanguage") || "en";
    sessionStorage.setItem("selectedLanguage", currentLang);
    sessionStorage.setItem("selectedLanguageDetails", JSON.stringify(languageMap[currentLang]));
  }, []);

  // Used this useEffect for handle the external user survey question page open or not
  useEffect(() => {
    const handleStorageChange = () => {
      const updatedValue = JSON.parse(sessionStorage.getItem("isExternalUserQuestionsPageOpen") || "false");
      setIsExternalUserQuePage(updatedValue);
    };
    window.addEventListener('sessionStorageUpdated', handleStorageChange);
    return () => {
      window.removeEventListener('sessionStorageUpdated', handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if(location.pathname === '/user/survey/opening-page/ques-page' || (location.pathname === '/user/survey/opening-page' && isExternalUserSurvey === 'false')){
      setIsUserSurveyQuePage(true)
    }else{
      setIsUserSurveyQuePage(false)
    }
  }, [isUserSurveyQuePage, location.pathname]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if the click was outside the user icon and popup
      if (
        popupRef.current && !popupRef.current.contains(event.target) &&
        userIconRef.current && !userIconRef.current.contains(event.target)
      ) {
        setIsPopupOpen(false); // Close the popup
      }

      if (
        langPopupRef.current && !langPopupRef.current.contains(event.target) &&
        langIconRef.current && !langIconRef.current.contains(event.target)
      ) {
        setIsLangPopupOpen(false);
      }
    };

    // Add event listener
    document.addEventListener('click', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [userIconRef]);

  const isAdminScreen = () => {
    if (
      headerName === "Level Management" ||
      headerName === "Template Management" ||
      headerName === "Slot Management" ||
      headerName === "PIC Management" ||
      headerName === "RCM Management"
    ) {
      return true;
    } else return false;
  };

  const handleLogout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    if (userNameObj?.idToken?.claims?.iss.includes("okta")) {
      await oktaAuth.signOut({
        postLogoutRedirectUri: process.env.REACT_APP_OKTA_LOGOUT_REDIRECT_URI || `${window.location.origin}/login`,
      });
    } else {
      instance.logoutRedirect({
        postLogoutRedirectUri: process.env.REACT_APP_MS_ENTRA_LOGOUT_REDIRECT_URI || `${window.location.origin}/login`,
      });
    }
    setActiveTab("Tab1");
  };

    const changeLanguage = (lng) => {
      i18n.changeLanguage(lng);
      setIsLangPopupOpen(false);
      
      sessionStorage.setItem("selectedLanguage", lng);
      sessionStorage.setItem("selectedLanguageDetails", JSON.stringify(languageMap[lng]));
    };

  useEffect(() => {
    const checkAssessment = () => {
      let found = !!document.querySelector('.assessment-container');
      if (!found) {
        const allElements = document.body.querySelectorAll('*');
        for (let el of allElements) {
          if (el.shadowRoot && el.shadowRoot.querySelector('.assessment-container')) {
            found = true;
            break;
          }
        }
      }
      setIsAssessmentPresent(found);
    };
    checkAssessment();
    const observer = new MutationObserver(checkAssessment);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, [location.pathname]);


  return (
    <div className={isLandingPage ? "header landing-header" : "header"}>
      {isLandingPage ? (
        <div className="landing-header-text" style={{ marginLeft: "0.8rem" }}>
          {t("globalCompliancePlatform")}
        </div>
      ) : (
        <div
          className={isSidebarOpen === false ? "sidebarHeader" : "header-text"}
        >
          {headerName}
        </div>
      )}
      <div className="header-user">
        {t("welcome")} {userName}
        {/* {localStorage.getItem("userEmail")} */}
        {isExternalUserSurvey === 'false' && (
          <span
            className="header-user-icon"
            onClick={() => setIsPopupOpen(!isPopupOpen)} // Toggle popup visibility
            style={{ cursor: "pointer" }}
            ref={userIconRef}
          >
            <svg
              width="16"
              height="auto"
              viewBox="0 0 22 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              data-tooltip-id="tooltip-user-profile"
              data-tooltip-content={t("userProfile") || "User Profile"}
            >
              <path
                d="M10.935 10.3333C13.5123 10.3333 15.6016 8.244 15.6016 5.66667C15.6016 3.08934 13.5123 1 10.935 1C8.35765 1 6.26831 3.08934 6.26831 5.66667C6.26831 8.244 8.35765 10.3333 10.935 10.3333Z"
                stroke="#454647"
                strokeWidth="1.33333"
                strokeLinecap="round"
              />
              <path
                d="M1.40157 17.5973C2.25357 14.4707 5.48824 13 8.72824 13H13.1416C16.3816 13 19.6162 14.4707 20.4696 17.5973C20.6551 18.2761 20.7866 18.9685 20.8629 19.668C20.9429 20.4013 20.3376 21 19.6016 21H2.26824C1.53224 21 0.928241 20.4 1.00691 19.6693C1.0831 18.9694 1.21596 18.2765 1.40157 17.5973Z"
                stroke="#454647"
                strokeWidth="1.33333"
                strokeLinecap="round"
              />
            </svg>
            <Tooltip
              id="tooltip-user-profile"
              place="bottom"
            />

            {isPopupOpen && (
              <ul
                className="popup-menu"
                ref={popupRef}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-11px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "9px solid transparent",
                    borderRight: "9px solid transparent",
                    borderBottom: "11px solid #ccc",
                    zIndex: 10,
                  }}
                />
                {/* Inner Arrow (Background fill) */}
                <div
                  style={{
                    position: "absolute",
                    top: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderBottom: "10px solid #fff",
                    zIndex: 11,
                  }}
                />
                <li className="logout-li log-li" onClick={handleLogout}>
                  <img src={logoutIcon} alt="Log out" />
                  {t("logOut")}
                </li>
              </ul>
            )}
          </span>
        )}
        {/* {isExternalUserSurvey === 'false' && !isAssessmentPresent && <span className="vertical-line"></span>}
        {isExternalUserSurvey === 'false' && !isAssessmentPresent && ( */}
        {(isExternalUserSurvey === 'false' || isExternalUserSurvey === 'true') && isExternalUserQuePage === false && !isAssessmentPresent && !isUserSurveyQuePage && <span className="vertical-line"></span>}
        {(isExternalUserSurvey === 'false' || isExternalUserSurvey === 'true') && isExternalUserQuePage === false && !isAssessmentPresent && !isUserSurveyQuePage && (
          <span
            className="lang-popup-trigger"
            style={{
              position: "relative",
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              marginLeft: "10px",
              verticalAlign: "middle",
              height: "32px",
            }}
            onClick={() => setIsLangPopupOpen((prev) => !prev)}
            ref={langPopupRef}
          >
            <img
              src={worldIcon}
              alt="Languages"
              className="globe"
              data-tooltip-id="tooltip-language"
              data-tooltip-content={t("preferredLanguage")}
            />
            <Tooltip
              id="tooltip-language"
              place="bottom"
            />
            {isLangPopupOpen && (
              <ul
                className="popup-menu language-option"
                ref={langIconRef}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-11px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "9px solid transparent",
                    borderRight: "9px solid transparent",
                    borderBottom: "11px solid #ccc",
                    zIndex: 10,
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    top: "-10px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    width: 0,
                    height: 0,
                    borderLeft: "8px solid transparent",
                    borderRight: "8px solid transparent",
                    borderBottom: "10px solid #fff",
                    zIndex: 11,
                  }}
                />
                <li
                  className={`logout-li ${selectedLanguage === "en" ? "selected-language" : ""
                    }`}
                  onClick={() => changeLanguage("en")}
                >
                  {t("english")}
                </li>
                 <li
                  className={`logout-li ${selectedLanguage === "jp" ? "selected-language" : ""
                    }`}
                  onClick={() => changeLanguage("jp")}
                >
                  {t("japanese")}
                </li>
                <li
                  className={`logout-li ${selectedLanguage === "ch" ? "selected-language" : ""
                    }`}
                  onClick={() => changeLanguage("ch")}
                >
                  {t("simplifiedChinese")}
                </li>
              </ul>
            )}
          </span>
        )}
      </div>
      <div
        className={isLandingPage ? "hitachi-right-logo" : "hitachi-right-logo1"}
      >
        <img src={hitachiLogo} alt="Hitachi Logo" className="hitachi-logo2" />
      </div>
    </div>
  );
};

export default Header;




